// extracted by mini-css-extract-plugin
export default {"moreInfoPosition":"authenticate_moreInfoPosition__VxmWg"};